import _get from 'lodash/get';

export default function getIsInMs365() {
  return _get(window, ['location', 'ancestorOrigins', '0'], '').includes('microsoft365');
}
